/**
 * @generated SignedSource<<abffdf757e7f892a6f6d4540f2be40ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientProfileScreenRefetchQuery$variables = {
  id: string;
};
export type ClientProfileScreenRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ClientProfileScreen_client">;
  } | null | undefined;
};
export type ClientProfileScreenRefetchQuery = {
  response: ClientProfileScreenRefetchQuery$data;
  variables: ClientProfileScreenRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "metricType",
  "value": "CHECKIN_ANSWER_MEASUREMENT"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calories",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trackingType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carbsGrams",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proteinGrams",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fatGrams",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "raw",
    "value": true
  }
],
v13 = {
  "alias": null,
  "args": (v12/*: any*/),
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(raw:true)"
},
v14 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM DD, YYYY"
  }
],
v15 = {
  "alias": null,
  "args": (v14/*: any*/),
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": "updatedAt(format:\"MMM DD, YYYY\")"
},
v16 = [
  (v3/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentCalories",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentFat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentCarbs",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentProtein",
    "storageKey": null
  },
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientNutritionEntry",
    "kind": "LinkedField",
    "name": "clientNutritionEntry",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MMM D, YYYY"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": (v12/*: any*/),
  "kind": "ScalarField",
  "name": "activityDate",
  "storageKey": "activityDate(raw:true)"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurement",
  "storageKey": null
},
v22 = [
  (v3/*: any*/),
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "value",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v21/*: any*/)
        ],
        "type": "CheckinAnswerMeasurementValue",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": (v14/*: any*/),
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": "createdAt(format:\"MMM DD, YYYY\")"
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "value",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
          },
          (v21/*: any*/)
        ],
        "type": "CheckinAnswerMeasurementValue",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientProfileScreenRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClientProfileScreen_client"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientProfileScreenRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          }
                        ],
                        "type": "CheckinAnswerMeasurementValue",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": "metrics(metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionTarget",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoNutrition",
                "kind": "LinkedField",
                "name": "autoNutrition",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "carbs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "protein",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "h:mm A, MMM DD, YYYY"
                  }
                ],
                "kind": "ScalarField",
                "name": "autoNutritionLastSync",
                "storageKey": "autoNutritionLastSync(format:\"h:mm A, MMM DD, YYYY\")"
              },
              {
                "alias": "autoNutritionMacroTarget",
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionMacroTarget",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TerraSdkOptions",
                "kind": "LinkedField",
                "name": "terraSdkOptions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "devId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referenceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "token",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionMacroTarget",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientNutritionTarget",
                "kind": "LinkedField",
                "name": "nutritionPortionTarget",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 9999
                  }
                ],
                "concreteType": "ClientGoalConnection",
                "kind": "LinkedField",
                "name": "goals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "targetValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentValue",
                            "storageKey": null
                          },
                          {
                            "alias": "formattedDate",
                            "args": (v18/*: any*/),
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": "date(format:\"MMM D, YYYY\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completed",
                            "storageKey": null
                          },
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": "goals(first:9999)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "units",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "fromNow"
                  }
                ],
                "kind": "ScalarField",
                "name": "lastLoginAt",
                "storageKey": "lastLoginAt(format:\"fromNow\")"
              },
              {
                "alias": "steps",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "STEP_COUNT"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v22/*: any*/),
                "storageKey": "metrics(measurementType:\"STEP_COUNT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "bodyWeight",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "BODYWEIGHT"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v22/*: any*/),
                "storageKey": "metrics(measurementType:\"BODYWEIGHT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "allMetrics",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": "metrics(limit:1,metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "bodyFat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "BODYFAT"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"BODYFAT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "chest",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "CHEST"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"CHEST\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "waist",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "WAIST"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"WAIST\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "hip",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "HIP"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"HIP\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "thigh",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "THIGH"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"THIGH\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "upperArm",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "UPPER_ARM"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"UPPER_ARM\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "calf",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "CALF"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"CALF\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": "shoulder",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "measurementType",
                    "value": "SHOULDER"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": "metrics(measurementType:\"SHOULDER\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": "photos",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "metricType",
                    "value": "CHECKIN_ANSWER_PROGRESS_PHOTO"
                  }
                ],
                "concreteType": "ClientMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "front",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "back",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "side",
                            "storageKey": null
                          }
                        ],
                        "type": "CheckinAnswerProgressPhotoValue",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "metrics(metricType:\"CHECKIN_ANSWER_PROGRESS_PHOTO\")"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 999
                  }
                ],
                "concreteType": "ClientFormConnection",
                "kind": "LinkedField",
                "name": "clientForms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientFormEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientForm",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "slug",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "submittedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": "createdAt(format:\"MMM D, YYYY\")"
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": "clientForms(first:999)"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2a9b0695c04832eeac4639c000b2d01",
    "id": null,
    "metadata": {},
    "name": "ClientProfileScreenRefetchQuery",
    "operationKind": "query",
    "text": "query ClientProfileScreenRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ClientProfileScreen_client\n    id\n  }\n}\n\nfragment ClientBodyWeightCard_client on User {\n  units\n  bodyWeight: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: BODYWEIGHT) {\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n      }\n    }\n  }\n}\n\nfragment ClientFormCardItem_clientForm on ClientForm {\n  slug\n  name\n  submittedAt\n  createdAt(format: \"MMM D, YYYY\")\n}\n\nfragment ClientFormsCard_client_21A5F9 on User {\n  clientForms(first: 999) {\n    edges {\n      node {\n        ...ClientFormCardItem_clientForm\n        id\n      }\n    }\n  }\n}\n\nfragment ClientGoal_goal on ClientGoal {\n  id\n  name\n  targetValue\n  currentValue\n  formattedDate: date(format: \"MMM D, YYYY\")\n  completed\n}\n\nfragment ClientGoalsCard_goals on ClientGoalConnection {\n  totalCount\n  edges {\n    node {\n      id\n      updatedAt(format: \"MMM DD, YYYY\")\n      ...ClientGoal_goal\n    }\n  }\n  ...ClientGoalsDrawer_goals\n}\n\nfragment ClientGoalsDrawer_goals on ClientGoalConnection {\n  totalCount\n  edges {\n    node {\n      id\n      name\n      targetValue\n      currentValue\n      date(raw: true)\n      formattedDate: date(format: \"MMM D, YYYY\")\n    }\n  }\n  ...ClientGoalsList_goals\n}\n\nfragment ClientGoalsList_goals on ClientGoalConnection {\n  edges {\n    node {\n      id\n      name\n      targetValue\n      currentValue\n      date(raw: true)\n      formattedDate: date(format: \"MMM D, YYYY\")\n    }\n  }\n}\n\nfragment ClientMeasurementItem_metrics on ClientMetric {\n  value {\n    __typename\n    ... on CheckinAnswerMeasurementValue {\n      unit\n      measurement\n    }\n  }\n}\n\nfragment ClientMeasurementsCard_client on User {\n  units\n  allMetrics: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, limit: 1) {\n    createdAt(format: \"MMM DD, YYYY\")\n    id\n  }\n  bodyFat: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: BODYFAT) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  chest: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: CHEST) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  waist: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: WAIST) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  hip: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: HIP) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  thigh: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: THIGH) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  upperArm: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: UPPER_ARM) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  calf: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: CALF) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n  shoulder: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: SHOULDER) {\n    ...ClientMeasurementItem_metrics\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n        unit\n      }\n    }\n  }\n}\n\nfragment ClientNutritionCard_autoNutrition on AutoNutrition {\n  calories\n  carbs\n  fat\n  protein\n}\n\nfragment ClientNutritionCard_autoNutritionMacroTarget on ClientNutritionTarget {\n  id\n  targetType\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n}\n\nfragment ClientNutritionCard_nutritionMacroTarget on ClientNutritionTarget {\n  id\n  trackingType\n  targetType\n  commentType\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n  currentCalories\n  currentFat\n  currentCarbs\n  currentProtein\n  date(raw: true)\n  clientNutritionEntry {\n    id\n    carbsGrams\n    proteinGrams\n    fatGrams\n    calories\n    date\n  }\n}\n\nfragment ClientNutritionCard_nutritionPortionTarget on ClientNutritionTarget {\n  id\n  trackingType\n  targetType\n  commentType\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n  currentCalories\n  currentFat\n  currentCarbs\n  currentProtein\n  date(raw: true)\n  clientNutritionEntry {\n    id\n    carbsGrams\n    proteinGrams\n    fatGrams\n    calories\n    date\n  }\n}\n\nfragment ClientNutritionCard_nutritionTarget on ClientNutritionTarget {\n  id\n  trackingType\n  targetType\n  commentType\n  carbsGrams\n  proteinGrams\n  fatGrams\n  calories\n  date(raw: true)\n  updatedAt(format: \"MMM DD, YYYY\")\n}\n\nfragment ClientProfileScreen_client on User {\n  metrics(metricType: CHECKIN_ANSWER_MEASUREMENT) {\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        type\n      }\n    }\n    id\n  }\n  nutritionTarget {\n    calories\n    ...ClientNutritionCard_nutritionTarget\n    id\n  }\n  autoNutrition {\n    id\n    ...ClientNutritionCard_autoNutrition\n  }\n  autoNutritionLastSync(format: \"h:mm A, MMM DD, YYYY\")\n  autoNutritionMacroTarget: nutritionMacroTarget {\n    ...ClientNutritionCard_autoNutritionMacroTarget\n    id\n  }\n  terraSdkOptions {\n    devId\n    referenceId\n    token\n  }\n  nutritionMacroTarget {\n    ...ClientNutritionCard_nutritionMacroTarget\n    id\n  }\n  nutritionPortionTarget {\n    ...ClientNutritionCard_nutritionPortionTarget\n    id\n  }\n  goals(first: 9999) {\n    edges {\n      cursor\n    }\n    ...ClientGoalsCard_goals\n  }\n  ...ClientSummary_client\n  ...ClientStepsCard_client\n  ...ClientBodyWeightCard_client\n  ...ClientMeasurementsCard_client\n  ...ClientProgressPhotosCard_client\n  ...ClientFormsCard_client_21A5F9\n  clientForms(first: 999) {\n    totalCount\n  }\n  id\n}\n\nfragment ClientProgressPhotosCard_client on User {\n  id\n  username\n  photos: metrics(metricType: CHECKIN_ANSWER_PROGRESS_PHOTO) {\n    id\n    createdAt(format: \"MMM DD, YYYY\")\n    value {\n      __typename\n      ... on CheckinAnswerProgressPhotoValue {\n        front\n        back\n        side\n      }\n    }\n  }\n}\n\nfragment ClientStepsCard_client on User {\n  units\n  steps: metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: STEP_COUNT) {\n    id\n    activityDate(raw: true)\n    value {\n      __typename\n      ... on CheckinAnswerMeasurementValue {\n        measurement\n      }\n    }\n  }\n}\n\nfragment ClientSummary_client on User {\n  id\n  displayName\n  email\n  photoURL\n  age\n  gender\n  weight\n  height\n  units\n  location\n  clientStatus\n  lastLoginAt(format: \"fromNow\")\n}\n"
  }
};
})();

(node as any).hash = "8c44ec1e2b0a14cfb6d9be48709b6556";

export default node;
